import React from "react";
import { Document } from "@react-pdf/renderer";

import PDF_Export_First_Page from "../Page/first";

// SZC report as a single vector PDF document (US Letter pages)
const PDF_Export_Document = ({
    language = "en",
    modelName,
    inputFieldsData,
    displayData,
    calcPerformedBy,
    displayUnits = "Metric",
}) => {
    return (
        <Document title={`${modelName}_cooling_zone_report_${language}`}>
            <PDF_Export_First_Page
                language={language}
                modelName={modelName}
                inputFieldsData={inputFieldsData}
                displayData={displayData}
                calcPerformedBy={calcPerformedBy}
                displayUnits={displayUnits}
            />
        </Document>
    );
};

export default PDF_Export_Document;
